// import Container from '@material-ui/core/Container';
// import Grid from '@material-ui/core/Grid';
// import Box from '@material-ui/core/Box';
// import Link from '@material-ui/core/Link';

import { Box, Link, Typography } from "@mui/material";
import SubTitle from "../components/SubTitle";
import Title from "../components/Title";

// "@mui/material"
export default function Footer() {
  return (
    <footer>
      <Box
        px={{ xs: 1, sm: 1 }}
        py={{ xs: 1, sm: 1 }}
        //bgcolor="text.primary"
        bgcolor="#4d4d4d"
        //bgcolor="secondary.light"
      >
        <Box
          textAlign="center"
          //  pt={{ lg:0, md:2, xs: 2, sm: 2}} pb={{ lg:2, md:2,xs: 2, sm: 0 }}
        >
          <Link
            href="https://www.idsl.me/"
            underline="always"
            target="_blank"
            rel="noreferrer"
          >
            <SubTitle color="white">
              Integrated Data Science Laboratory for Metabolomics and Exposomics
              (IDSL.ME),
            </SubTitle>
          </Link>
          <Link
            href="https://icahn.mssm.edu/about/departments/environmental-public-health"
            underline="always"
            target="_blank"
            rel="noreferrer"
          >
            <SubTitle color="white">
              Department of Environmental Medicine and Public Health (EPMH),
            </SubTitle>
          </Link>
          {/* <Title>and</Title> */}
          <Link
            href="https://sinaiexposomics.org/"
            underline="always"
            target="_blank"
            rel="noreferrer"
          >
            <SubTitle color="white">
              {" "}
              The Institute for Exposomic Research,
            </SubTitle>
          </Link>
          <Link
            href="https://icahn.mssm.edu/"
            underline="always"
            target="_blank"
            rel="noreferrer"
          >
            <SubTitle color="white">
              Icahn School of Medicine at Mount Sinai (ISMMS), New York, USA.
            </SubTitle>
          </Link>
          {/* <SubTitle color="white">New York, USA</SubTitle> */}
        </Box>
      </Box>
    </footer>
  );
}
